<!DOCTYPE html>
<html>
<head>
	<title>Tabla Salud Total</title>
	<meta charset="utf-8">
	<meta name="viewport" content="user-scalable=no, width=device-width, initial-scale=1">
	<link rel="stylesheet" type="text/css" href="../css/styles.css">
	<link rel="stylesheet" type="text/css" href="../assets/css/styles.css">
</head>
<body>
	<div class="wraper"  style="margin-bottom:0px;">
		<div class="filters">
			<div class="conteSelect">
				<select ngModel="_selectedProducto" (change)="onChangeProductos($event)" style="padding-right: 30px;">
					<option hidden [value]=""  selected>PRODUCTO </option>
					<option *ngFor="let producto of _resultProductos" value="{{ producto.codigoPro }}">
						 {{producto.nombrePro | uppercase}}
					 </option>	
				  </select>
			</div>
			<div class="conteSelect">
				<select ngModel="_selectedSucursal" (change)="onChangeSucursales($event)" style="padding-right: 30px;">
					<option hidden [value]=""  selected>SUCURSAL </option>
					<option *ngFor="let sucursal of _resultSucursales" value="{{ sucursal.codigoSu }}">
							{{sucursal.nombreSu | uppercase}}
					</option>	
				</select>
			</div>

			<div class="conteSelect">
				<select ngModel="_selectedServicio" (change)="onChangeServicios($event)" style="padding-right: 30px;">
					<option hidden [value]=""  selected>SERVICIO </option>
					<option *ngFor="let servicio of _resultServicios" value="{{ servicio.codigoSG }}">
							{{servicio.nombreSG | uppercase}}
					</option>	
				</select>
			</div>
			<div class="conteSelect">
				<select ngModel="_selectedEspecialidad" (change)="onChangeEspecialidades($event)" style="padding-right: 30px;">
					<option hidden [value]=""  selected>ESPECIALIDAD </option>
					<option *ngFor="let especialidad of _resultEspecialidades" value="{{ especialidad.codigoEs }}">
						{{especialidad.nombreEs | uppercase}}
					</option>	
				</select>
			</div>
		</div>
		<div class="specialty {{_plan}}">
			<h3>{{_nombreEspecialidad}}</h3>
			<p>{{_descripcionEspecialidad}}</p>
		</div>
		<!-- <div class="conteTable">
			<table cellspacing="0" cellpadding="0">
				<thead class="{{_plan}}">
					<tr>
						<th>Clínica</th>
						<th>Dirección</th>
						<th>Teléfono</th>
						<th>Médico</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let item of _resultDirectorioPAC">
						<td>{{item.sede}}</td>
						<td><img src="assets/scalableVectorGraphics/img/icon_marker.svg">{{item.direccion}}</td>
						<td><img src="assets/scalableVectorGraphics/img/icon_phone.svg">{{item.telefono}}</td>
						<td>
							<table cellspacing="0" cellpadding="0">
								<tr *ngFor="let esp of item.especialistas.split(', ')">
									<td style="border: none; margin-bottom:10px; padding: 0px;" *ngIf="item.especialistas != ''"><ul><li>{{esp}}</li></ul></td>
								</tr>
							</table>
						</td>
					</tr>
				</tbody>
			</table>
		</div> -->
	</div>

	<div class="wraperFixed"> <!-- CarlosPaH -->				
		<mat-grid-list cols="2" rowHeight="1:1" >
			<mat-grid-tile class="gridTileFixed" ><!-- CarlosPaH -->
				<div class="conte-tile"><!-- CarlosPaH -->
				@if (_shouldFitBounds) {	
                    <mat-accordion style="width: 90%; margin-top: 100px; height: fit-content;"  ng-repeat="centroAtencion in _resultDirectorioPAC" ng-model='_resultDirectorioPAC'>
                        <ng-container *ngFor="let centroAtencion of _resultDirectorioPAC">
                            <mat-expansion-panel style="margin-bottom: 30px;">
                                <mat-expansion-panel-header>
                                <mat-panel-title>
                                    {{centroAtencion.sede}}
                                </mat-panel-title>
                                </mat-expansion-panel-header>
                            <p class="datContacto"><strong>Teléfono: </strong>{{centroAtencion.telefono}}</p><!-- CarlosPaH -->
                            <p class="datContacto"><strong>Dirección: </strong>{{centroAtencion.direccion}}</p><!-- CarlosPaH -->
                            <a href="#" class="gradient" *ngIf='!((centroAtencion.latitud) == 0 || (centroAtencion.longitud) == 0 || centroAtencion.longitud == "" || centroAtencion.latitud == "")'
                                    (click)="ComoLlegar(centroAtencion.latitud, centroAtencion.longitud)">
                                <img src="assets/img/icon_location.svg" width="18px" style="margin-bottom: -5px;"> ¿Cómo llegar?
                                </a>
                            </mat-expansion-panel>
                        </ng-container>
                    </mat-accordion>
                }
				</div>
				
			</mat-grid-tile>
			<mat-grid-tile>	
				<div class="conte-map">
                    <div id="map" style="height: 600px; width: 100%;"></div>
                </div>
            </mat-grid-tile>
		</mat-grid-list>
	</div> 
	
	<section>
		<footer>
			<img src="assets/img/logo_super_salud.svg" alt="PiePagina" width="100%">
		</footer>
	</section>

</body>
</html>
